import { Modal, ModalHeader } from "reactstrap";
import { H3, P } from "../../../../../AbstractElements";
import UpdateAddrForm from "./UpdateAddrForm";

interface ModalProps {
  EmpNo: string;
  modal: boolean;
  toggle?: () => void;
}

const UpdateAddressModal: React.FC<ModalProps> = ({ EmpNo, modal, toggle }) => {
  return (
    <>
      <Modal
        size="lg"
        isOpen={modal}
        toggle={toggle}
        backdrop="static"
        keyboard={false}
      >
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <ModalHeader className="border-0">
            <H3>Update Employee Address</H3>
            <button onClick={toggle} className="btn-close"></button>
            <P className="mb-0">
              Review and update the employee's address details to ensure all
              information is accurate and complete.
            </P>
          </ModalHeader>
          <UpdateAddrForm EmpNo={EmpNo} toggle={toggle} />
        </div>
      </Modal>
    </>
  );
};

export default UpdateAddressModal;
